module.exports = __webpack_public_path__ + "img/2.b7813d58.gif";